import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

import Spacer from '~/components/Spacer'
import DesktopContainer from '~/components/DesktopContainer'

import Header from './Header'
// import Footer from './Footer'
import BasicFooter from '~/components/dashboard/Layout/Footer/BasicFooter'
import Hero from './Hero'

const Background = styled.div`
  background: ${props => props.theme.colors.background.main};
  display: flex;
  flex-grow: 1;
  font-family: ${props => props.theme.fonts.avenirNextRegular};
  font-size: 1rem;
  line-height: 1.5rem;
`

const GRID_THEME = {
  flexboxgrid: {
    // Defaults
    gridSize: 12, // columns
    gutterWidth: 2, // rem
    outerMargin: 0, // rem
    mediaQuery: 'only screen',
    container: {
      sm: 46, // rem
      md: 61, // rem
      lg: 76 // rem
    },
    breakpoints: {
      xs: 0, // em
      sm: 48, // em
      md: 64, // em
      lg: 75 // em
    }
  }
}

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <Hero />
      <Background>
        <DesktopContainer fullHeight>
          <Spacer mobile={20} desktop={20} />
          <ThemeProvider theme={GRID_THEME}>{children}</ThemeProvider>
        </DesktopContainer>
        <Spacer mobile={20} desktop={20} />
      </Background>
      <BasicFooter />
    </>
  )
}

export default Layout
